import {
  Box,
  Button,
  Checkbox,
  MenuItem,
  Paper,
  Select,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Toolbar,
  IconButton,
  Popper,
  Fade,
  PopperPlacementType,
} from "@mui/material";
// import axios from "axios";
import React, { useEffect, useState } from "react";
import api from "../../../../../API";
import { useSelector } from "react-redux";
import _debounce from 'lodash/debounce';
import { GridCloseIcon } from "@mui/x-data-grid";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const KmWorkerAsgDialog = (props: any) => {

  const [open, setOpen] = useState(true);

  const [user_info, setUser_info] = useState<any>(null);

  const [asg_cnt, setAsg_cnt] = useState<number>(0);

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  const handleClose = () => {
    props.setDialogOpen(false);
  };

  const workerAssignment = async (asg_cnt:number) => {

    if(props.asg_ready_cnt < asg_cnt){
      alert("할당 가능한 건수를 초과하였습니다.")
      return;
    }

    const formData = new FormData();

    formData.append("email", email);

    formData.append("isp1_user", props.dclickUser.user_id);

    formData.append("asg_cnt", asg_cnt.toString());

    await api.post("/km-isp-assignment",formData)
    .then((res:any) => { alert("할당이 완료되었습니다."); props.updateAfter(); handleClose(); })
    .catch((error:any) => {alert('오류 - '+ error.response.data.error);})

  }

  const getUserIdInfo = async () => {
    // setBackdrop(true)
    var result = await api.get("/getAuthsByUserId", {
      params: {email:email,user_id:props.dclickUser.user_id}
    });
    console.log("result.data", result.data);
   
    setUser_info(result.data)
    // console.log('swWorkList',swWorkList)
    // setSwWorkers(swWorkList)
    // setBackdrop(false)
  }


  useEffect(() => {
    if(props.dclickUser != undefined){
    // console.log('열림?',props)
      getUserIdInfo()
    }
    // if(props.dclickUser != undefined){
    //   handleOpen()
    // }
  }, [props]);

  return (

    <Box>
      <Dialog maxWidth="md" open={true} onClose={handleClose}>
        <DialogTitle sx={{padding: "16px 24px 0px 24px"}}>
          <Box display="flex">
            <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>KHM. KM 데이터 할당</Box>
            <IconButton
              sx={{marginLeft: "auto", marginRight: "94px", backgroundColor: "#ff9494"}}
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <GridCloseIcon />
            </IconButton>
          </Box>
          <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
        </DialogTitle>
        <DialogContent dividers>

          <Paper sx={{width:"100%", overflow: "auto"}}>
            <Box sx={{margin:"1px 20px 0px 20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>할당가능 건수 : <b style={{color:"#38c73d"}}>{props.asg_ready_cnt}</b> 건</Box>
            <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
            <Box>
                <Box display="flex">
                  <Box display="flex" sx={{marginLeft: "50px"}}>
                    
                    {user_info && 
                      <Box sx={{width:"100%"}}>
                        <Box m={0.5} display="flex" sx={{alignItems:"center"}}>
                          <Box sx={{fontSize:"24px",marginRight:"16px",fontWeight:700}}>이름 :</Box>
                          <Box sx={{fontSize:"24px"}}>{user_info.name}</Box>
                        </Box>
                        <Box m={0.5} display="flex" sx={{alignItems:"center"}}>
                          <Box sx={{fontSize:"24px",marginRight:"16px",fontWeight:700}}>유저ID:</Box>
                          <Box sx={{fontSize:"24px"}}>{user_info.user_id}</Box>
                        </Box>
                        <Box m={0.5} display="flex" sx={{alignItems:"center",marginTop:"16px"}}>
                          <Box sx={{fontSize:"24px",marginRight:"16px",fontWeight:700}}>할당건수 입력</Box>
                          <TextField size="small" id="asg_cnt" value={asg_cnt} onChange={(e)=>setAsg_cnt(Number(e.target.value))} sx={{width:"100px",height: "40px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}} />
                        </Box>
                      </Box>
                    }
                    
                    </Box>
                  </Box>

            </Box>
            
          </Paper>

          <DialogActions>
            <Button variant="contained" sx={{fontWeight:700, margin:"8px 16px"}}
              onClick={() => {
                workerAssignment(asg_cnt);
              }}
            >
              할당
            </Button>
          </DialogActions>

        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default KmWorkerAsgDialog;
